import clsx from "clsx"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../../util/dates"
import styles from "./styles.module.css"

interface AttachedMedia {
  url: string
  [key: string]: any
}

interface Location {
  displayName?: string
  [key: string]: any
}

interface MiniLinkPreviewPost {
  post_type?: string
  event_type?: string
  location?: Location
  external_photo_src?: string
  attached_media?: AttachedMedia[]
  cover_image_url_small?: string
  cover_image_url_medium?: string
  cover_image_url_large?: string
  cover_photo_url_square?: string
  cover_photo_url_small?: string
  nada_path: string
  title: string
  title_cleaned?: string
  band_name: string
  published_at: string
}

interface MiniLinkPreviewProps {
  post: MiniLinkPreviewPost
}

export const MiniLinkPreview: React.FC<MiniLinkPreviewProps> = ({ post }) => {
  let postType = post.post_type
  if (postType?.indexOf("video") > -1) {
    postType = "video"
  }

  const postDisplayName =
    post.event_type === "inPersonEvent" && post.location?.displayName
      ? post.location?.displayName?.indexOf(",") > -1
        ? post.location?.displayName?.split(",")[0]
        : post.location?.displayName
      : null

  // Ordered by preference, not just a single pick - the small cover variant
  // can individually fail to process/serve even when the post has a
  // perfectly good cover image (other sizes, or the band's photo, still
  // work). attached_media[0] is the raw, unprocessed original upload for
  // posts with a custom cover image, so it's a last resort, not the primary
  // candidate.
  const imageCandidates = [
    post.external_photo_src,
    post.cover_image_url_small,
    post.cover_image_url_medium,
    post.cover_image_url_large,
    post.cover_photo_url_square,
    post.cover_photo_url_small,
    post.attached_media?.length > 0 ? post.attached_media[0].url : undefined,
  ].filter((url): url is string => !!url)

  const [candidateIndex, setCandidateIndex] = useState(0)
  const postImage = imageCandidates[candidateIndex]

  return (
    <Link
      className={clsx(styles.container, "border flex items-center")}
      to={post.nada_path}
    >
      {postImage && (
        <img
          className={styles.image}
          src={postImage}
          alt={post.title}
          onError={() => setCandidateIndex((i) => i + 1)}
        />
      )}
      <div className={styles.content}>
        <h1
          className={clsx(styles.heading, "leading-tight text-black-800")}
          dangerouslySetInnerHTML={{
            __html: post.title_cleaned || post.title,
          }}
        ></h1>
        <div>
          <h2 className={styles.bandName}>{post.band_name}</h2>
          <p className={styles.itemDescription}>
            {postDisplayName
              ? `Live In-Person Event @ ${postDisplayName}`
              : postType}{" "}
            -{" "}
            {SmartDateFormat({
              dateStr: post.published_at,
              includeTime: false,
            })}
          </p>
        </div>
      </div>
    </Link>
  )
}
